var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBottomSponsor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.15669 0.822119C5.15669 0.368075 5.52479 0 5.97886 0C6.43293 0 6.80103 0.368075 6.80103 0.822119V11.2132L10.5965 7.418C10.9175 7.09694 11.4381 7.09694 11.7592 7.418C12.0803 7.73906 12.0803 8.2596 11.7592 8.58066L6.58033 13.7592C6.25925 14.0803 5.73869 14.0803 5.41761 13.7592C5.39638 13.738 5.37655 13.7159 5.35813 13.693C5.32947 13.6601 5.3034 13.6248 5.28023 13.5875L0.240808 8.54842C-0.0802688 8.22736 -0.0802695 7.70682 0.240807 7.38576C0.561884 7.06471 1.08245 7.06471 1.40353 7.38576L5.15669 11.1387V0.822119Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBottomSponsor);
export default __webpack_public_path__ + "static/media/arrow-bottom-sponsor.b75e2d274572af4f5af4c587a5a58cba.svg";
export { ForwardRef as ReactComponent };